import Reveal from '../../../shared/Reveal/Reveal';
import { useEconomicCalendarSimpleWorkflowContent } from '../../../../hooks/useEconomicCalendarSimpleWorkflowContent';
import './SimpleWorkflow.css';

const SimpleWorkflow = () => {
  const { content, isLoading } = useEconomicCalendarSimpleWorkflowContent();

  if (isLoading || !content) {
    return null;
  }

  const { title, steps } = content;

  return (
    <section className="simple-workflow">
      <div className="simple-workflow__inner">
        <Reveal>
          <h2 className="simple-workflow__title">{title}</h2>
        </Reveal>

        <div className="simple-workflow__steps">
          {steps.map(({ number, title: stepTitle, description }, index) => (
            <Reveal key={stepTitle} delay={index * 80} className="simple-workflow__step">
              <p className="simple-workflow__number">{number}</p>
              <h3 className="simple-workflow__step-title">{stepTitle}</h3>
              <p className="simple-workflow__step-text">{description}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SimpleWorkflow;
